import type { TeamRole } from '../lib/roles';
import { ROLE_LABELS, ROLE_COLORS } from '../lib/roles';

interface RoleBadgeProps {
  role: TeamRole;
  size?: 'sm' | 'md';
}

export default function RoleBadge({ role, size = 'sm' }: RoleBadgeProps) {
  const colors = ROLE_COLORS[role] || ROLE_COLORS.VIEWER;
  const label = ROLE_LABELS[role] || role;

  const sizeClasses = size === 'sm'
    ? 'px-2 py-0.5 text-xs'
    : 'px-2.5 py-1 text-sm';

  const dotSize = size === 'sm' ? 'h-1.5 w-1.5' : 'h-2 w-2';

  return (
    <span className={`inline-flex items-center gap-1.5 rounded-full font-medium ${colors.bg} ${colors.text} ${sizeClasses}`}>
      <span className={`rounded-full ${colors.dot} ${dotSize}`} />
      {label}
    </span>
  );
}
